import { roles } from "constants/index";

export const rolesGetAllShop = [roles.admin, roles.qs, roles.regionManager, roles.viceRegionManager, roles.seniorAreaManager]

export const rolesManualSync = [roles.admin]

export const rolesNotEdit = [roles.qs, roles.seniorAreaManager]